module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.9456fa40.otf";